// src/utils/roleUtils.ts

import { User } from '../types';

/**
 * Проверить, есть ли у пользователя роль TEACHER или ADMIN
 */
export const isTeacherOrAdmin = (user: User | null): boolean => {
    if (!user || !user.roles) return false;
    return user.roles.includes('ROLE_TEACHER') || user.roles.includes('ROLE_ADMIN');
};

/**
 * Проверить, есть ли у пользователя роль STUDENT
 */
export const isStudent = (user: User | null): boolean => {
    if (!user || !user.roles) return false;
    return user.roles.includes('ROLE_STUDENT');
};

/**
 * Проверить, есть ли у пользователя роль ADMIN
 */
export const isAdmin = (user: User | null): boolean => {
    if (!user || !user.roles) return false;
    return user.roles.includes('ROLE_ADMIN');
};

/**
 * Проверить, есть ли у пользователя конкретная роль
 */
export const hasRole = (user: User | null, role: string): boolean => {
    if (!user || !user.roles) return false;
    return user.roles.includes(role);
};